import { useCallback } from 'react';

import type { DocParts } from '@aline/common';
import { useDocumentParts } from 'src/hooks';

import { exportDocumentDialogVar } from './ExportDocumentDialog';
import { ExportDocumentCommentsMode, hasPrivateCommentsForExport } from './filterCommentsForExport';
import { useDownloadDOCXWithLoading } from './useDownloadDOCX';

export function useInitiateDocxExport() {
  const { getDocumentParts } = useDocumentParts();
  const { downloadDOCXWithLoading } = useDownloadDOCXWithLoading();

  const initiateDocxExport = useCallback(
    async (
      documentId: UUID,
      options: { docParts: DocParts; name: string },
      exportOptions?: { commentsMode?: ExportDocumentCommentsMode }
    ) => {
      if (!exportOptions?.commentsMode) {
        const { comments } = await getDocumentParts(documentId);
        if (hasPrivateCommentsForExport(comments)) {
          exportDocumentDialogVar({
            open: true,
            pending: { documentId, ...options },
          });
          return;
        }
      }

      await downloadDOCXWithLoading(documentId, {
        ...options,
        commentsMode: exportOptions?.commentsMode ?? ExportDocumentCommentsMode.PublicOnly,
      });
    },
    [downloadDOCXWithLoading, getDocumentParts]
  );

  return { initiateDocxExport };
}
